import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, RefreshCw, ArrowLeft, HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export function UserPaymentError() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="bg-card border-border p-8 max-w-md w-full text-center">
        {/* Error icon */}
        <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-red-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-white mb-2">Payment Failed</h1>
        <p className="text-muted-foreground mb-6">
          We couldn't process your payment. Please try again or use a different payment method.
        </p>

        {/* Error details */}
        <Card className="bg-red-500/10 border-red-500/30 p-4 mb-6 text-left">
          <div className="flex items-start gap-3">
            <HelpCircle className="w-5 h-5 text-red-500 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-red-400">Error Code: PAYMENT_DECLINED</p>
              <p className="text-xs text-muted-foreground mt-1">
                Your card was declined. Please check your card details or contact your bank.
              </p>
            </div>
          </div>
        </Card>

        {/* Suggestions */}
        <div className="text-left mb-6">
          <p className="text-sm text-white font-medium mb-2">What you can try:</p>
          <ul className="text-sm text-muted-foreground space-y-1">
            <li>• Check your card details are correct</li>
            <li>• Ensure you have sufficient funds</li>
            <li>• Try a different payment method</li>
            <li>• Contact your bank if the issue persists</li>
          </ul>
        </div>

        {/* Actions */}
        <div className="space-y-3">
          <Link to="/events/evt-001/tickets">
            <Button className="w-full bg-primary text-primary-foreground hover:bg-primary/90">
              <RefreshCw className="w-4 h-4 mr-2" />
              Try Again
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full border-border">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Events
            </Button>
          </Link>
        </div>

        <p className="text-xs text-muted-foreground mt-6">
          Need help? <Link to="#" className="text-primary hover:underline">Contact Support</Link>
        </p>
      </Card>
    </div>
  );
}

export default UserPaymentError;
